import { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAxios } from '../../utils/hook/useAxios';

const FIELDS_LEFT = [
  { key: 'FirstName', label: 'Prénom', type: 'text', autoComplete: 'given-name' },
  {
    key: 'lastName',
    label: 'Nom',
    type: 'text',
    placeholder: 'Nom de famille',
    autoComplete: 'family-name',
  },
  { key: 'dateNaissance', label: 'Date de naissance', type: 'date', autoComplete: 'bday' },
  {
    key: 'phoneNumber',
    label: 'Numéro de téléphone',
    type: 'tel',
    placeholder: '+33 6 56 67 89 00',
    autoComplete: 'tel',
  },
];

const FIELDS_RIGHT = [
  { key: 'city', label: 'Ville', type: 'text', autoComplete: 'address-level2' },
  {
    key: 'country',
    label: 'Pays',
    type: 'text',
    placeholder: 'Pays de résidence',
    autoComplete: 'country-name',
  },
  { key: 'tvaNumber', label: 'Numéro TVA', type: 'text', placeholder: '456008' },
];

function ProfileData({ user }) {
  const [isHovered, setIsHovered] = useState(false);
  const [data, setData] = useState(null);
  const axios = useAxios();

  const [PermisConduire, setPermisConduire] = useState(null);
  const [PieceIdentite, setPieceIdentite] = useState(null);
  const [ExpertVitesseManuelle, setExpertVitesseManuelle] = useState(null);
  const [FirstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [dateNaissance, setDateNaissance] = useState('');
  const [city, setCity] = useState('');
  const [country, setCountry] = useState('');
  const [immat, setImmat] = useState('');
  const [tvaNumber, setTvaNumber] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [PermisConduireDoc, setPermisConduireDoc] = useState(null);
  const [PieceIdentiteDoc, setPieceIdentiteDoc] = useState(null);

  useEffect(() => {
    let fetchUser = async () => {
      try {
        const response = await axios.get(`/users/searchbyid/${user?.id}`);
        const u = response.data;

        setData(u);

        // on lit la réponse (et non `data`, qui n'est pas encore à jour)
        setPermisConduire(u?.PermisConduire);
        setPieceIdentite(u?.PieceIdentite);
        setFirstName(u?.firstName ?? '');
        setLastName(u?.lastName ?? '');
        setDateNaissance(u?.dateNaissance ?? '');
        setCity(u?.city ?? '');
        setCountry(u?.country ?? '');
        setImmat(u?.immatriculation ?? '');
        setTvaNumber(u?.tvaNumber ?? '');
        setPhoneNumber(u?.phoneNumber ?? '');
        setExpertVitesseManuelle(u?.ExpertVitesseManuelle);
        setPermisConduireDoc(u?.PermisConduireDoc);
        setPieceIdentiteDoc(u?.PieceIdentityDoc);
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  useEffect(() => {
    let saveFlags = async () => {
      try {
        if (data) {
          await axios.put(`/users/` + user?.id, {
            ExpertVitesseManuelle: ExpertVitesseManuelle == 1 ? 1 : 0,
            PermisConduireDoc: PermisConduireDoc,
            PieceIdentityDoc: PieceIdentiteDoc,
          });
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    saveFlags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PermisConduire, PieceIdentite, ExpertVitesseManuelle, PermisConduireDoc, PieceIdentiteDoc]);

  function handleApprouver() {
    let Approuve = async () => {
      try {
        const responseOption = await axios.put(`/users/` + user?.id, {
          firstName: FirstName,
          lastName: lastName,
          dateNaissance: dateNaissance,
          city: city,
          country: country,
          immatriculation: immat,
          phoneNumber: phoneNumber,
          tvaNumber: tvaNumber,
        });
        if (responseOption.data) {
          toast.success('Les infos personnels ont bien été mise à jour avec succèss.');
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    Approuve();
  }

  const handleImageUpload = (event, setImage) => {
    const file = event.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'r6s4af83');

    fetch('https://api.cloudinary.com/v1_1/dtrkcpsky/image/upload', {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((res) => setImage(res.secure_url))
      .catch((error) => console.error('Error uploading image to Cloudinary:', error));
  };

  const values = { FirstName, lastName, dateNaissance, phoneNumber, city, country, tvaNumber };
  const setters = {
    FirstName: setFirstName,
    lastName: setLastName,
    dateNaissance: setDateNaissance,
    phoneNumber: setPhoneNumber,
    city: setCity,
    country: setCountry,
    tvaNumber: setTvaNumber,
  };

  const renderField = (f) => {
    const id = `gs-profile-${f.key}`;
    const raw = values[f.key] ?? '';
    const value = f.type === 'date' ? String(raw).substring(0, 10) : raw;
    return (
      <div key={f.key}>
        <label className="mc-field-label" htmlFor={id}>
          {f.label}
        </label>
        <input
          id={id}
          className="mc-input"
          type={f.type}
          value={value}
          placeholder={f.placeholder}
          autoComplete={f.autoComplete}
          disabled={!isHovered}
          onChange={(e) => setters[f.key](e.target.value)}
        />
      </div>
    );
  };

  return (
    <>
      <ToastContainer />

      <div className="mc-gs-card">
        <div className="mc-gs-card-head">
          <h2 className="mc-gs-card-title">Informations personnelles</h2>

          <div className="mc-gs-actions">
            {isHovered ? (
              <>
                <button
                  type="button"
                  className="mc-btn mc-btn--ghost mc-btn--sm"
                  onClick={() => setIsHovered(false)}
                >
                  Annuler
                </button>
                <button
                  type="button"
                  className="mc-btn mc-btn--primary mc-btn--sm"
                  onClick={handleApprouver}
                >
                  <i className="bi bi-check2" aria-hidden="true"></i>
                  Enregistrer
                </button>
              </>
            ) : (
              <button
                type="button"
                className="mc-btn mc-btn--secondary mc-btn--sm"
                onClick={() => setIsHovered(true)}
              >
                <i className="bi bi-pencil" aria-hidden="true"></i>
                Modifier
              </button>
            )}
          </div>
        </div>

        {/** 
        <div className="mc-gs-tiles">
          <label className={`mc-gs-tile${PermisConduireDoc ? ' is-done' : ''}`}>
            <i
              className={`bi ${PermisConduireDoc ? 'bi-check-circle-fill' : 'bi-upload'}`}
              aria-hidden="true"
            ></i>
            Permis de conduire
            <input
              type="file"
              onChange={(event) => handleImageUpload(event, setPermisConduireDoc)}
            />
          </label>

          <label className={`mc-gs-tile${PieceIdentiteDoc ? ' is-done' : ''}`}>
            <i
              className={`bi ${PieceIdentiteDoc ? 'bi-check-circle-fill' : 'bi-upload'}`}
              aria-hidden="true"
            ></i>
            Pièce d'identité
            <input
              type="file"
              onChange={(event) => handleImageUpload(event, setPieceIdentiteDoc)}
            />
          </label>
        </div>
   */}
        <div className="mc-gs-fields">
          <div className="mc-stack">{FIELDS_LEFT.map(renderField)}</div>
          <div className="mc-stack">{FIELDS_RIGHT.map(renderField)}</div>
        </div>

        <div className="mc-gs-banner mc-gs-banner--info mc-gs-submit" role="note">
          <i className="bi bi-info-circle" aria-hidden="true"></i>
          <span>La plupart des véhicules en France sont en boîte de vitesse automatique.</span>
        </div>

        <button
          type="button"
          className="mc-btn mc-btn--secondary mc-gs-submit"
          aria-pressed={ExpertVitesseManuelle === 1}
          onClick={() => setExpertVitesseManuelle(ExpertVitesseManuelle === 1 ? 0 : 1)}
        >
          {ExpertVitesseManuelle === 1 && (
            <i className="bi bi-check-circle-fill" aria-hidden="true"></i>
          )}
          Êtes-vous expert en vitesse manuelle ?
        </button>
      </div>
    </>
  );
}

export default ProfileData;
